import { client } from '../common/client';
import type { SubmitContactRequest, SubmitContactResponse } from './utils/types';

// Single source of truth for the contact submission endpoint.
// Maps to the Facade's public `POST /contactUs` route (creates a Gorgias ticket).
const CONTACT_ENDPOINT = '/contactUs';

class ContactAPIClient {
  public async submitContact(payload: SubmitContactRequest): Promise<SubmitContactResponse> {
    return await client.post(CONTACT_ENDPOINT, payload).then((res) => res.data);
  }
}

export const contactAPIClient = new ContactAPIClient();
